const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    tags: [],
    author: "",
    search: "",
    page: 1
};

const filterSlice = createSlice({
    name: "video",
    initialState,
    reducers: {
        tagSelected: (state, action) => {
            state.page = 1;
            state.tags.push(action.payload);
        },
        tagRemoved: (state, action) => {
            const indexToRemove = state.tags.indexOf(action.payload);

            if (indexToRemove !== -1) {
                state.page = 1;
                state.tags.splice(indexToRemove, 1);
            }
        },
        searched: (state, action) => {
            state.page = 1;
            state.search = action.payload;
        },
        searchAuthor: (state,action) => {
            state.tags = [];
            state.search = "";
            state.page = 1;
            state.author = action.payload;
        },
        setPageNumber: (state, action) => {
            state.page = action.payload;
        },
        resetFilter: (state, action) => {
            state.tags = [];
            state.search = "";
            state.author = "";
            state.page = 1;
        },
    },
});

export default filterSlice.reducer;
export const { tagSelected, tagRemoved, searched, searchAuthor, resetFilter, setPageNumber } = filterSlice.actions;
